import { Outlet, useLocation } from 'react-router'
import { Menu } from 'lucide-react'
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet'
import { IPVPSidebar, SidebarContent } from '../components/Sidebar'
import { OrganizationSidebarContent } from '../components/OrganizationSidebar'

export default function AuthenticatedLayout() {
  const location = useLocation()

  // Check if current route is organization route
  const isOrganizationRoute = location.pathname.startsWith('/organization')

  // Determine active item based on current pathname
  const getActiveItem = (pathname: string) => {
    if (pathname.startsWith('/dashboard')) return 'dashboard'
    if (pathname.startsWith('/assessment')) return 'assessment'
    if (pathname.startsWith('/results')) return 'results'
    if (pathname.startsWith('/learning-path')) return 'learning-path'
    if (pathname.startsWith('/settings')) return 'settings'
    return 'dashboard' // default
  }

  const activeItem = getActiveItem(location.pathname)

  return (
    <div className='flex h-screen bg-[#EDEFF3]'>
      {/* Sidebar - Conditional based on route */}
      {isOrganizationRoute ? (
        <aside className='hidden lg:block w-[300px] border-r border-gray-200 bg-white'>
          <OrganizationSidebarContent />
        </aside>
      ) : (
        <IPVPSidebar activeItem={activeItem} />
      )}

      {/* Main Content */}
      <div className='flex-1 flex flex-col overflow-hidden'>
        {/* Mobile top bar with hamburger menu (couple pages only) */}
        {!isOrganizationRoute && (
          <div className='lg:hidden flex items-center px-4 py-3 bg-white border-b border-[#E5E7EB]'>
            <Sheet>
              <SheetTrigger asChild>
                <button className='p-2 hover:bg-gray-100 rounded-lg transition-colors'>
                  <Menu className='h-6 w-6 text-gray-700' />
                </button>
              </SheetTrigger>
              <SheetContent side='left' className='p-0 w-[280px]'>
                <SidebarContent activeItem={activeItem} />
              </SheetContent>
            </Sheet>
          </div>
        )}
        <main className='flex-1 overflow-y-auto'>
          <Outlet />
        </main>
      </div>
    </div>
  )
}
